import { UseMutationResult, useMutation, useQueryClient } from "react-query";

import { useAxios } from "../../hooks/useAxios";
import { IFetchAvatarResponse } from "../../types";

export interface IResetAvatarItemsArgs {
  user_id: string;
}

export default function useResetAvatar(): UseMutationResult<
  IFetchAvatarResponse,
  unknown,
  IResetAvatarItemsArgs
> {
  const axios = useAxios();
  const queryClient = useQueryClient();

  const resetAvatar = async (args: IResetAvatarItemsArgs) => {
    const { user_id } = args;

    const response = await axios({
      method: "post",
      url: `/v1/avatar/${user_id}/items/reset`,
    }).then((r) => r.data as IFetchAvatarResponse);

    queryClient.invalidateQueries("avatar", { exact: true });

    return response;
  };

  const mutation = useMutation(resetAvatar);

  return mutation;
}
